/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  UserSessionClient,
  UserSessionClient$inboundSchema,
} from "./usersessionclient.js";

/**
 * Result type for listing user_session_clients.
 */
export type ListUserSessionClientsResult = {
  items: Array<UserSessionClient>;
  /**
   * Cursor for the next page; empty when exhausted.
   */
  nextCursor?: string | undefined;
};

/** @internal */
export const ListUserSessionClientsResult$inboundSchema: z.ZodMiniType<
  ListUserSessionClientsResult,
  unknown
> = z.pipe(
  z.object({
    items: z.array(UserSessionClient$inboundSchema),
    next_cursor: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "next_cursor": "nextCursor",
    });
  }),
);

export function listUserSessionClientsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListUserSessionClientsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListUserSessionClientsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListUserSessionClientsResult' from JSON`,
  );
}
